import { render, staticRenderFns } from "./MerchantIdCreate.vue?vue&type=template&id=3a62bc8c&scoped=true"
import script from "./MerchantIdCreate.vue?vue&type=script&lang=js"
export * from "./MerchantIdCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a62bc8c",
  null
  
)

export default component.exports